<template>
  <div id="partnerships" class="purple-box">
    <div class="area-header --uppercase">{{ $t('ui.partnerships') }}</div>    
    
    <template v-for="block in partnershipBlocks">
      <div 
        class="pitch-area-partnerships" 
        :key="block.area" 
        :data-area="block.area">
        <div class="area-subheader --uppercase">
          <a :href="block.detailsLink" target="_blank">{{ $t(block.name) }} &gt;</a>
        </div>
        <template v-for="partnership in block.partnerships">
          <div 
            class="data-table-row" 
            :class="(!counts[block.area] || !counts[block.area][partnership.type] || !counts[block.area][partnership.type][partnership.show]) && 'data-table-row--null-value'"
            :key="partnership.name">
            <div
              class="line-colour-key"
              :class="keyColour(block.area, partnership)">
            </div>
            <div class="--capitalise-first-letter">{{ $t(partnership.name) }}</div>
            <div 
              class="partnership-count" 
              :data-type="partnership.type" 
              :data-show="partnership.show">
              {{ counts[block.area] && counts[block.area][partnership.type] ? counts[block.area][partnership.type][partnership.show] || "-" : "-" }}
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import PartnershipTypes from "@/assets/js/partnership-types";

export default {
  name: 'ThePartnershipsCount',
  data: () => {
    return {
      partnershipBlocks: [
        { 
          area: "centralMidfield",
          detailsLink: "https://www.guidetofm.com/tactics/choosing-roles-duties/3/#forward-movement-partnerships",
          name: 'tactics.pitchAreas.centralMidfield',
          partnerships: [
            { name: "tactics.partnerships.lowRiskDirect", type: "lowRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskOverlapping", type: "mediumRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskDirect", type: "mediumRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.balancedInterchanging", type: "interchanging", show: PartnershipTypes.balanced },
            { name: "tactics.partnerships.highRiskOverlapping", type: "highRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.highRiskDirect", type: "highRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.overloadingInterchanging", type: "interchanging", show: PartnershipTypes.overloading }
          ]
        },
        { 
          area: "centralAttack",
          detailsLink: "https://www.guidetofm.com/tactics/choosing-roles-duties/5/#forward-movement-partnerships-3",
          name: 'tactics.pitchAreas.centralAttack',
          partnerships: [
            { name: "tactics.partnerships.highRiskOverlapping", type: "highRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.highRiskDirect", type: "highRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskOverlapping", type: "mediumRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskDirect", type: "mediumRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.balancedInterchanging", type: "interchanging", show: PartnershipTypes.balanced },
            { name: "tactics.partnerships.overloadingInterchanging", type: "interchanging", show: PartnershipTypes.overloading }
          ]
        },
        { 
          area: "leftFlank",
          detailsLink: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
          name: 'tactics.pitchAreas.leftFlank',
          partnerships: [
            { name: "tactics.partnerships.highRiskOverlapping", type: "highRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.highRiskDirect", type: "highRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.overloadingDirect", type: "highRiskDirect", show: PartnershipTypes.overloading },
            { name: "tactics.partnerships.mediumRiskOverlapping", type: "mediumRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskDirect", type: "mediumRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.balancedInterchanging", type: "interchanging", show: PartnershipTypes.balanced },
            { name: "tactics.partnerships.overloadingInterchanging", type: "interchanging", show: PartnershipTypes.overloading }
          ]
        },
        { 
          area: "rightFlank",
          detailsLink: "https://www.guidetofm.com/tactics/choosing-roles-duties/4/#forward-movement-partnerships-2",
          name: 'tactics.pitchAreas.rightFlank',
          partnerships: [
            { name: "tactics.partnerships.highRiskOverlapping", type: "highRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.highRiskDirect", type: "highRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.overloadingDirect", type: "highRiskDirect", show: PartnershipTypes.overloading },
            { name: "tactics.partnerships.mediumRiskOverlapping", type: "mediumRiskOverlapping", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.mediumRiskDirect", type: "mediumRiskDirect", show: PartnershipTypes.imbalanced },
            { name: "tactics.partnerships.balancedInterchanging", type: "interchanging", show: PartnershipTypes.balanced },
            { name: "tactics.partnerships.overloadingInterchanging", type: "interchanging", show: PartnershipTypes.overloading }
          ]
        },
      ]
    }
  },

  methods: {
    keyColour(zone, partnership) {
      const classList = [];
      if (!this.counts[zone] ||
          !this.counts[zone][partnership.type] ||
          !this.counts[zone][partnership.type][partnership.show]) {
        return classList;
      }
      classList.push('partnership__colour-key');

      if (partnership.type.includes("highRisk")) {
        classList.push('--high-risk');
      } else if (partnership.type.includes("lowRisk")) {
        classList.push('--low-risk');
      }

      if (partnership.type.includes("Direct")) {
        classList.push('--direct');
      } else if (partnership.type.includes("Overlapping")) {
        classList.push('--overlapping');
      } else if (partnership.show === PartnershipTypes.balanced) {
        classList.push('--balanced');
      }
      return classList;
    }
  },

  computed: {
    counts() {
      return this.$store.getters.partnershipCounts;
    }
  }
}
</script>


<style scoped>
.data-table-row--null-value {
  opacity: 0.55;
}

.partnership__colour-key {
  opacity: 0.87;
  background-color: black;
  height: 5px;
}

.--direct {
  background-color: #d62687;
}

.--overlapping {
  background-color: #dad12e;
}

.--balanced {
  background-color: #343ddb;
}

.--low-risk {
  height: 2px;
}

.--high-risk {
  height: 7px;
}
</style>
